module.exports = __webpack_public_path__ + "static/media/boston-celtics.e20c85a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/svg/boston-celtics.svg
// module id = 230
// module chunks = 0